import type { ReactNode } from 'react'
import { useSidebar, SIDEBAR_WIDTH_MOBILE } from '@/components/ui/sidebar-context'
import { cn } from '@/lib/utils'

/** The portalled navigation and this app surface move by the same distance. */
export function MobileNavFrame({ children, className }: { children: ReactNode; className?: string }) {
  const { isMobile, openMobile } = useSidebar()

  if (!isMobile) return children

  return (
    <div className="h-full w-full overflow-hidden">
      <div
        data-mobile-app-frame
        className={cn('flex h-full min-h-0 w-full flex-col transition-transform duration-300 ease-out motion-reduce:transition-none', className)}
        style={{ transform: openMobile ? `translateX(${SIDEBAR_WIDTH_MOBILE})` : 'translateX(0)' }}
      >
        {children}
      </div>
    </div>
  )
}
